<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW')" />
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <!-- <Divider layout="vertical"/> -->            
            <Button label="저장" icon="pi pi-save" class="mr-2" @click="btnAct('SAVE')" />
            <Button label="삭제" icon="pi pi-trash" class="p-button-danger mr-2" @click="btnAct('DELETE')" :disabled="isCustUser"/>
            <!-- <Divider layout="vertical"/> -->
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
            <ProgressSpinner style="width:40px;height:40px" class="p-component mr-2" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" aria-label="Loading" v-show="isProgress" />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="upperSeq" v-model="searchParams.unitCd" :options ="cboMenuCodes1" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changeUpperSeq"  />
                        <label for="upperSeq">대분류</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="menuSeq" v-model="searchParams.pgmCd" :options ="cboMenuCodes2" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="menuSeq">화면명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="title" type="text" v-model="searchParams.title" :options ="publicCodes" style="width: 16rem"/>
                        <label for="title">제목</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="notice" type="text" v-model="searchParams.notice" :options ="publicCodes" style="width: 16rem"/>
                        <label for="notice">내용</label>
                    </div>
                </div> 
            </template>

            <template #end>
    
            </template>
        </Toolbar>
        
        <Splitter style="height: 79vh">
            <SplitterPanel :size="55">
                <template #header>
                    <i class="pi pi-calendar" style="padding:5px"></i>
                    <span>수정사항요청 목록</span>
                </template>
                <DataTable  id="dt" ref="dt" :value="dataList" :scrollable="true" scrollHeight="750px" 
                    selectionMode="single" :metaKeySelection="false" v-model:selection="selectedItems" 
                    editMode="cell" @cell-edit-complete="onCellEditComplete" class="editable-cells-table p-datatable-sm" 
                    @rowSelect="onRowSelect" @rowUnselect="onRowUnselect" showGridlines
                     responsiveLayout="scroll">
                     <template #header>
                        <i class="pi pi-calendar"></i>
                        <span>수정사항 목록</span>
                    </template>
                    <Column field="giveYmd" header="요청일자" :sortable="true" style="min-width: 10em; max-width: 10em" exportFooter=" ">
                        <template #body="{ data, field }">
                            {{ convertDateString(data[field]) }}
                        </template>
                    </Column>
                    <Column field="tretStFg" header="처리상태" :sortable="true" style="min-width: 10em; max-width: 10em" exportFooter=" ">
                        <template #body="{data}">
                            {{(tretStFg.find(e=>e.code == data.tretStFg)||{codeNm:""})['codeNm']}}
                        </template>
                    </Column>
                    <Column field="giveTitle" header="요청제목" :sortable="true" style="min-width:35em; max-width: 35em" exportFooter=" "></Column>
                    <Column field="userNm" header="작성자" :sortable="true" style="min-width: 10em; max-width: 10em" exportFooter=" "></Column> 
                    <Column field="attachSeq" header="attachSeq" hidden exportFooter=" "></Column>
                </DataTable>
            </SplitterPanel>

            <SplitterPanel :size="45">
                <Splitter style="height: 75vh" layout="vertical">
                    <SplitterPanel :size="50">
                        <div class="p-field" style="background-color:#EAEDED; padding:0.25em; border: 0.4em;">
                            <span><i class="pi pi-calendar"></i> 수정사항 내용</span>
                        </div>
                            <form class="p-fluid">
                                <div class="p-field">
                                    <div class="grid">
                                        <div class="col">
                                            <label for="corpNm" class="col-fixed" style="width:150px">업체</label>
                                            <!-- <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" /> -->
                                        </div>
                                        <div class="col">
                                            <InputText v-model.trim="selectedModify.corpNm" />
                                        </div>
                                        <div class="col">
                                            <InputText v-model.trim="selectedModify.corpSeq" />
                                        </div>
                                        <div class="col">
                                            <label for="userNm" class="col-fixed" style="width:100px">작성자</label>
                                        </div>
                                        <div class="col">
                                            <InputText v-model.trim="selectedModify.userNm" />
                                        </div>
                                        <div class="col">
                                            <InputText v-model.trim="selectedModify.userId" />
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field">
                                    <div class="grid">
                                        <div class="col-2">
                                            <label for="unitCd" class="col-fixed" style="min-width:100px">대분류</label>
                                        </div>
                                        <div class="col">
                                            <Dropdown id="unitCd" v-model="selectedModify.unitCd" :options ="cboMenuCodes1" optionLabel="codeNm" optionValue="code" :showClear="true"
                                            @change="changeUpperSeq2"  />
                                        </div>
                                        <div class="col-2">
                                            <label for="pgmCd" class="col-fixed" style="width:100px">화면명</label>
                                        </div>
                                        <div class="col">
                                            <Dropdown id="pgmCd" v-model="selectedModify.pgmCd" :options ="cboMenuCodes2" optionLabel="codeNm" optionValue="code" :showClear="true"/>
                                            <!-- <Dropdown id="menuSeq" v-model="searchParams.pgmCd" :options ="cboMenuCodes2" optionLabel="codeNm" optionValue="code" :showClear="true"/> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field">
                                    <div class="grid">
                                        <div class="col-2">
                                            <label for="giveTret" class="col-fixed" style="min-width:100px">요청분류</label>
                                        </div>
                                        <div class="col">
                                            <Dropdown id="giveTret" v-model="selectedModify.giveTret" :options ="giveTret" optionLabel="codeNm" optionValue="code" :showClear="true"/>
                                        </div>
                                        <div class="col-2">
                                            <label for="giveYmd" class="col-fixed" style="width:100px">요청일자</label>
                                        </div>
                                        <div class="col">
                                            <Calendar v-model="selectedModify.giveYmd" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar/>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field">
                                    <div class="grid">
                                        <div class="col-2">
                                            <label for="giveTitle" class="col-fixed" style="width:100px">요청제목</label>
                                        </div>
                                        <div class="col">
                                            <InputText v-model.trim="selectedModify.giveTitle" />
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field">
                                    <div class="grid">
                                        <div class="col-2">
                                            <label for="giveData" class="col-fixed" style="width:100px">요청내용</label>
                                        </div>
                                        <div class="col">
                                            <Textarea v-model.trim="selectedModify.giveData" :autoResize="true" rows="4" cols="50" />
                                        </div>
                                    </div>
                                </div>
                            </form>
                    </SplitterPanel>  

                    <SplitterPanel :size="30">
                        <template #header>
                            <i class="pi pi-calendar"></i>
                            <span>첨부파일</span>
                        </template>
                        <Toolbar>
                            <template #end>
                                <!--  1048576000 b -> 1GB  -->
                                <FileUpload mode="basic" :multiple="true" :maxFileSize="1048576000" :auto="true" chooseLabel="추가"  @select="selectFiles" class="p-button-help mr-2"/>
                                <Button label="삭제" icon="pi pi-minus" class="p-button-danger mr-2" @click="btnAct('FILE_DELETE') "/>
                                <Button label="다운" icon="pi pi-download" class="p-button-help mr-2" @click="btnAct('FILE_DOWNLOAD') "/>
                            </template>
                        </Toolbar>
                        <DataTable id="dt" ref="dt" :value="selectedModify.attachList" v-model:selection="selectedfilesdata" showGridlines 
                            rowIndexVar="rowIndex" :loading="loading" 
                            scrollable="true" scrollHeight="200px" class="p-datatable-sm" responsiveLayout="scroll">
                            <Column header="No" style="min-width:3em; max-width:3em">
                                <template #body="{index}">
                                    {{ index + 1 }}
                                </template>    
                            </Column>
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="originFileNm" header="*파일명" :sortable="true" headerClass="required-field"></Column>
                            <Column field="fileSize" header="파일크기" :sortable="true"></Column>
                            <Column :exportable="false" style="min-width:4rem; max-width: 4rem">
                                <template #body="{data}">
                                    <Button icon="pi pi-download" class="p-button-rounded p-button-success" @click="downloadFile(data)" />
                                </template>
                            </Column>
                        </DataTable>
                    </SplitterPanel> 
                    <SplitterPanel :size="20">
                        <form class="p-fluid">
                            <div class="p-field">
                                <div class="grid">
                                    <div class="col-2">
                                        <label for="accYmd" class="col-fixed" style="min-width:100px">접수일자</label>
                                    </div>
                                    <div class="col">
                                        <Calendar v-model="selectedModify.accYmd" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar/>
                                    </div>
                                    <div class="col-2">
                                        <label for="tretStFg" class="col-fixed" style="width:100px">처리상태</label>
                                    </div>
                                    <div class="col">
                                        <Dropdown id="tretStFg" v-model="selectedModify.tretStFg" :options ="tretStFg" optionLabel="codeNm" optionValue="code" :showClear="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="p-field">
                                <div class="grid">
                                    <div class="col-2">
                                        <label for="tretStData" class="col-fixed" style="width:100px">처리내역</label>
                                    </div>
                                    <div class="col">
                                        <Textarea v-model.trim="selectedModify.tretStData" :autoResize="true" rows="2" cols="50" />
                                    </div>
                                </div>
                            </div>
                            <div class="p-field">
                                <div class="grid">
                                    <div class="col-2">
                                        <label for="tretStChr" class="col-fixed" style="min-width:100px">담당자</label>
                                    </div>
                                    <div class="col">
                                        <InputText v-model.trim="selectedModify.tretStChr" readonly/>
                                    </div>
                                    <div class="col-2">
                                        <label for="endYmd" class="col-fixed" style="width:100px">완료일자</label>
                                    </div>
                                    <div class="col">
                                        <Calendar v-model="selectedModify.endYmd" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </SplitterPanel>
                </Splitter>
            </SplitterPanel> 
        </Splitter>

    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import CodeService from '@/service/cm/CodeService';
import MA601080Service from '@/service/ma/MA601080Service';
//import AttachFileService from '@/service/cm/AttachFileService';
import AttachFileService from '@/service/cm/AttachFileService';
import JsUtils from '@/utilities/JsUtils';


export default {
    setup() { 
        onMounted(() => {
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                    isCustUser.value = true;
                }
            }

            // 검색조건에 시작일자,종료일자를 표시한다
            //let date = new Date();  
            //let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            //searchParams.fromDate = JsUtils.getDateString(fromDate);            
            //searchParams.toDate = JsUtils.getDateString(new Date());          // 현재 일자

			codeService.getCodeList({ compSeq:searchParams.compSeq, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:searchParams.compSeq, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
            codeService.getCodeList({ compSeq:searchParams.compSeq, upCode:'_area_tag'}).then(data=> cboAreaTags.value = data);  // 영역분류 코드
            codeService.getCodeList({ compSeq:searchParams.compSeq, upCode:'_run_tag'}).then(data=> cboRunTags.value = data);  // 운행분류 코드
            codeService.getTableCodeList({ sqlId:'menulist_code', compSeq:1, upperSeq:0}).then(data => cboMenuCodes1.value = data);  // 메뉴 코드
        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const ma601080Service = new MA601080Service();
        const searchParams = reactive({});
        const dataList = ref([]);
        const selectedModify = ref({attachList:[{}]}); 
        const selectedItems = ref([]);
        const selectedfilesdata = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const useOilTagCodes = ref([]);
        const cboAreaTags = ref([]);
        const cboRunTags = ref([]);
        const cboCarNos = ref([]);
        const cboMenuCodes1 = ref([]);
        const cboMenuCodes2 = ref([]);
        const confirm = useConfirm();
        const toast = useToast();
        const attachFileService = new AttachFileService();
        const fileSave = ref([]); //실질적인 파일 저장하는 변수 insert 

        // 로딩표시
        const isProgress = ref(false);

        const yns = ref([
            {codeNm: '사용', code: 1},
            {codeNm: '중지', code: 2}
        ])

        // 처리상태
        const tretStFg = ref([
            {codeNm: '신청', code: '1'},
            {codeNm: '접수', code: '2'},
            {codeNm: '수정중', code: '3'},
            {codeNm: '처리완료', code: '4'}
        ]);

        // 요청 분류
         const giveTret = ref([
            {codeNm: '프로그램수정요청', code: '1'},
            {codeNm: '업무수정요청', code: '2'}
        ])

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "NEW":
                    initNotice();
                    break;
                case "SEARCH":
                    searchMA601080();
                    break;
                case "SAVE":
                    saveNotice();
                    break;
                case "DELETE":
                    deleteNotice();
                    break;
                case "FILE_DELETE":
                    filedelete();
                    break;
                case "FILE_DOWNLOAD":
                    filedownload();
                    break;
                default:
            }
        }

        const searchMA601080 = () => {
            //searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            //searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);
            fileSave.value = [];
            
            ma601080Service.getList(searchParams).then(data => {                 
                dataList.value = data;

                if(dataList.value.length > 0){
                    var _params = {compSeq:dataList.value[0].compSeq, noticeSeq:dataList.value[0].noticeSeq, attachSeq:dataList.value[0].attachSeq};
                        // 목록에서 선택된 건에 대한 공지사항에 대한 상세정보를 얻어온다
                        ma601080Service.getOne(_params).then(data => {
                        //alert(JSON.stringify(data))
                        selectedModify.value = data;

                        cboMenuCodes2.value = [];
                        // 현재 선택된 대분류로 화면 목록을 가져와서 표시한다
                        var _upperSeq = selectedModify.value.unitCd;
                        if(_upperSeq == 6) {
                            _upperSeq = 19;
                        }
                        codeService.getTableCodeList({sqlId:'menulist_code', compSeq:searchParams.compSeq, upperSeq:_upperSeq}).then(data => {
                            cboMenuCodes2.value = data;    
                        });
                    }); 
                }
            });
        };

        const initNotice = () => {
            
            // 회원의 정보를 가져와야한다.
            const _user = JSON.parse(localStorage.getItem("user"));   // sessionStorage는 페이지 세션이 끝날때 제거된다
            //alert("### _user = " + JSON.stringify(_user));

            let today =  JsUtils.getDateString(new Date());
            selectedModify.value = {compSeq: _user.compSeq, userNm: _user.fullNm, userId: _user.username, email: _user.email, giveYmd: today, giveTret: '1', tretStFg: '1', corpId: _user.corpId};

            //var _params = {compSeq:event.data.compSeq, noticeSeq:event.data.noticeSeq, attachSeq:event.data.attachSeq};

            // 목록에서 선택된 건에 대한 공지사항에 대한 상세정보를 얻어온다
            // ma601070Service.getOne(_params).then(data => {
            //     //alert(JSON.stringify(data))
            //     selectedModify.value = null;
            // });
        };

        const saveNotice = () => {
                // 내용 확인
                //alert(JSON.stringify(selectedModify.value));

                // 필수 입력
                if(!JsUtils.checkUndefineColumns(selectedModify.value, ["giveYmd","giveTitle","unitCd","pgmCd","giveTret"])){
                    toast.add({severity:'warn', summary:'필수입력 확인', detail:'대분류,화면명,요청분류, 요청일자, 제목은 필수입력 해야합니다.', life:2000});
                    return;
                }

                // 날짜 조정
                selectedModify.value.giveYmd = JsUtils.convertDateToString(selectedModify.value.giveYmd);
                selectedModify.value.accYmd = JsUtils.convertDateToString(selectedModify.value.accYmd);
                selectedModify.value.endYmd = JsUtils.convertDateToString(selectedModify.value.endYmd);

                // 게시글 수정 
                if(selectedModify.value.modifySeq != null) {
                      confirm.require({
                        message:'수정하시겠습니까?',
                        header: '수정',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            isProgress.value = true;
                            ma601080Service.updateOneFileList(selectedModify.value, fileSave.value).then(() => {
                                toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                                //selectedModify.value = {};
                                //fileSave.value = [];
                                //btnAct('SEARCH');
                                isProgress.value = false;
                            })
                             .catch(error => {
                                if (error.response) {
                                    toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                                } else if (error.request) {
                                    toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                                } else {
                                    toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                                }
                            });
                        },
                          reject: () => {
                            toast.add({severity:'error', summary:'취소', life: 3000});
                        }
                    });
                } // 게시글 추가
                else {
                    confirm.require({
                        message:'저장하시겠습니까?',
                        header: '저장',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            isProgress.value = true;
                            ma601080Service.insertOneFileList(selectedModify.value, fileSave.value).then(() => {
                                toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                                selectedModify.value = {};
                                fileSave.value = [];
                                btnAct('SEARCH');
                                isProgress.value = false;
                            })
                            .catch(error => {
                                if (error.response) {
                                    toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                                } else if (error.request) {
                                    toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                                } else {
                                    toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                                }
                            });
                        },
                        reject: () => {
                            toast.add({severity:'error', summary:'취소', life: 3000});
                        }
                    });
                }
        };

        const deleteNotice = () => {
             confirm.require({
                message:'삭제하시겠습니까?',
                header: '삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    isProgress.value = true;
                    ma601080Service.deleteOne(selectedModify.value).then(() => {
                        selectedModify.value = {};
                        fileSave.value = [];
            
                        btnAct('SEARCH');
                        isProgress.value = false;
                    })
                    .catch(error => {
                        if (error.response) {
                        toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                        toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                        } else {
                        toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                        }
                     });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        };

        const changeUpperSeq = () => {
            cboMenuCodes2.value = [];
            // 현재 선택된 대분류로 화면 목록을 가져와서 표시한다
            var _upperSeq = searchParams.unitCd;
            if(_upperSeq == 6) {
                _upperSeq = 19;
            }
            codeService.getTableCodeList({sqlId:'menulist_code', compSeq:searchParams.compSeq, upperSeq:_upperSeq}).then(data => {
                cboMenuCodes2.value = data;
            });
        }

        const changeUpperSeq2 = () => {
            cboMenuCodes2.value = [];
            // 현재 선택된 대분류로 화면 목록을 가져와서 표시한다
            var _upperSeq = selectedModify.value.unitCd;
            if(_upperSeq == 6) {
                _upperSeq = 19;
            }
            codeService.getTableCodeList({sqlId:'menulist_code', compSeq:searchParams.compSeq, upperSeq:_upperSeq}).then(data => {
                cboMenuCodes2.value = data;
            });
        }

        const changeCustSeq = () => {
            cboCarNos.value = [];
            // 현재 선택된 업체에 속한 차량번호 목록을 다시 조회하여 Dropdown 목록에 표시한다
            codeService.getTableCodeList({ sqlId:'car_code', compSeq:searchParams.compSeq, corpId: searchParams.corpId}).then(data=> {
                cboCarNos.value = data;
            });
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

          // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 날짜 출력 변환
        const convertDateString = (data) => {
            return JsUtils.convertDateString(data);
        }

        const onRowSelect = (event) => {
            selectedModify.value = {};

            var _params = {compSeq:event.data.compSeq, modifySeq:event.data.modifySeq, attachSeq:event.data.attachSeq};

            // 목록에서 선택된 건에 대한 공지사항에 대한 상세정보를 얻어온다
            ma601080Service.getOne(_params).then(data => {
                //alert(JSON.stringify(data))
                selectedModify.value = data;

                cboMenuCodes2.value = [];
                // 현재 선택된 대분류로 화면 목록을 가져와서 표시한다
                var _upperSeq = selectedModify.value.unitCd;
                if(_upperSeq == 6) {
                    _upperSeq = 19;
                }
                codeService.getTableCodeList({sqlId:'menulist_code', compSeq:searchParams.compSeq, upperSeq:_upperSeq}).then(data => {
                    cboMenuCodes2.value = data;    
                });
            });
        }

        //선택한 파일 처리
        const selectFiles = (event) => {

            if(selectedModify.value.attachList == null){ selectedModify.value.attachList = new Array();}
            
            if(selectedModify.value.attachList.find(e => event.files.find(f => e.originFileNm == f.name))){
                toast.add({severity:'error', summary: '추가 오류', detail: "해당 파일 명칭이 중복 되는 것이 있습니다. 추가 하실 수 없습니다.", life: 3000});
            } else{
                for(var i = 0; i < event.files.length; i++){
                    //화면상에 보여줄 데이터를 넣는다.
                    //파일 항목에 표시한다.
                    selectedModify.value.attachList.push({originFileNm:event.files[i].name, fileSize:event.files[i].size , fileGbn:event.files[i].type});

                    //추가로 선택한 파일들에 대해서 insert 할 데이터를 넣는다.
                    fileSave.value.push(event.files[i]);
                }
            }
        }

        // 파일 항목을 삭제한다.
        const filedelete = () => {
             confirm.require({
                message:'삭제하시겠습니까?',
                header: '삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    isProgress.value = true;
                    attachFileService.deleteList(selectedfilesdata.value).then(() => {
                        //selectedModify.value = {};
                        //selectedfilesdata.value = [];
                        //fileSave.value = [];
                        //btnAct('SEARCH');
                        isProgress.value = false;
                        var _params = {compSeq:selectedModify.value.compSeq, noticeSeq:selectedModify.value.noticeSeq, attachSeq:selectedModify.value.attachSeq};
                        attachFileService.getList(_params).then(data => {
                            //fileSave.value = [];
                            //alert(JSON.stringify(data));
                            //selectedNotice.attachList
                            selectedModify.value.attachList = data;
                        });
                    })
                    .catch(error => {
                        if (error.response) {
                        toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                        toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                        } else {
                        toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                        }
                     });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        };

        //파일을 다운로드 한다.
        const filedownload = async () => {

            if(selectedfilesdata.value.length === 0 ){
                toast.add({severity:'error', summary: '다운로드 오류', detail: "파일을 다운로드 하기 위해서는 하나이상의 파일을 선택 해야 합니다.", life: 3000});
                return;
            }

            for(var i = 0; i < selectedfilesdata.value.length; i++){

                if(selectedfilesdata.value[i].attachSerl == null){
                    toast.add({severity:'error', summary: '다운로드 오류', detail: "저장하지 않은 파일은 다운로드 받을 수 없습니다.", life: 3000});
                    return;
                }

                var fileNm =  selectedfilesdata.value[i].originFileNm;
                var attachfile = {compSeq:selectedfilesdata.value[i].compSeq, attachSeq:selectedfilesdata.value[i].attachSeq, attachSerl:selectedfilesdata.value[i].attachSerl};

                await attachFileService.getDownload(attachfile).then((data) => {
                    const fileURL = window.URL.createObjectURL(new Blob([data]));
                    const fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNm);
                    fileLink.style.cssText = 'display:none';
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    fileLink.remove(); 
                    //URL.revokeObjectURL(fileLink.href);  // URL 리소스를 지우기 위해 호출한다
                });
            }
        }

        // 하나의 파일을 다운로드 한다
        const downloadFile = (data) => {
            var fileNm = data.originFileNm;
            var attachfile = {compSeq:data.compSeq, attachSeq:data.attachSeq, attachSerl:data.attachSerl}

            attachFileService.getDownload(attachfile).then((data) => {
                const fileURL = window.URL.createObjectURL(new Blob([data]));
                const fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileNm);
                fileLink.style.cssText = 'display:none';
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove(); 
                //URL.revokeObjectURL(fileLink.href);  // URL 리소스를 지우기 위해 호출한다
            })
            .catch(function (error) {
                toast.add({severity:'error', summary: '파일 다운로드 오류', detail: error.message, life: 3000});
            });
        }

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, cboAreaTags, cboRunTags, cboCarNos, cboMenuCodes1, cboMenuCodes2, selectedModify,
            yns, custCodes, formatToPrice, selectedItems, selectedfilesdata, convertDateString, tretStFg, giveTret, selectFiles, isProgress, isCustUser,
            btnAct, downloadExcel, exportCSV, changeUpperSeq, changeCustSeq, onRowSelect, saveNotice , initNotice , deleteNotice, changeUpperSeq2,
            downloadFile
        }

    }
}
</script>

<style lang="scss" scoped>

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
